import { createUseStyles } from 'react-jss'

import { zIndex10 } from '../../styles/const/common'
import { phonesDown, tabletDown } from '../../styles/const/breakpoints'
import { mainBackgroundColor } from '../../styles/const/colors'
import { topDrawerPadding } from '../../styles/common/drawerForms'

const useStyles = createUseStyles({
  closeBtn: {
    position: 'absolute',
    top: 40,
    right: 40,
    width: 22,
    height: 22,
    backgroundColor: mainBackgroundColor,

    '& svg': {
      width: 20,
      height: 20
    }
  },
  content: {
    position: 'fixed',
    top: 0,
    right: 0,
    zIndex: zIndex10,
    width: '50%',
    height: '100vh',
    transition: 'width .3s ease-out, transform .3s ease-out'
  },
  bodyContainer: {
    height: '100%',
    overflowY: 'auto',
    padding: '0 20px',
    position: 'relative',
    background: mainBackgroundColor
  },
  body: {
    paddingTop: topDrawerPadding,
    maxWidth: 406,
    margin: '0 auto',
    height: '100%'
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    right: 0,
    zIndex: zIndex10,
    width: '100vw',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, .5)',
    transition: 'opacity .3s ease-out',
    opacity: isOpen => (isOpen ? 1 : 0)
  },

  [`@media screen and (${tabletDown})`]: {
    content: {
      width: '60%'
    }
  },
  [`@media screen and (${phonesDown})`]: {
    content: {
      width: '100%'
    },
    closeBtn: {
      top: 20,
      right: 20
    }
  }
})

export default useStyles
